var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h5', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link",
    staticStyle: {
      "float": "right",
      "padding-left": "0px",
      "padding-right": "0px",
      "margin-left": "11px"
    },
    attrs: {
      "type": "button",
      "title": "Refresh"
    },
    on: {
      "click": function($event) {
        _vm.refreshTickeSummary()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh text-primary",
    staticStyle: {
      "font-size": "17px"
    }
  })]), _vm._v(" "), _c('basic-select', {
    staticStyle: {
      "float": "right",
      "width": "10%",
      "margin-top": "-8px",
      "height": "30px",
      "min-height": "25px",
      "padding": "7px",
      "font-size": "0.9rem"
    },
    attrs: {
      "id": "summaryType",
      "options": _vm.SummaryOptionObj,
      "selected-option": _vm.SummarySelectOptionObj
    },
    on: {
      "select": _vm.SummaryOption
    }
  }), _vm._v(" "), (_vm.HubNameDiv) ? _c('basic-select', {
    staticStyle: {
      "float": "right",
      "width": "10%",
      "margin-top": "-8px",
      "height": "30px",
      "min-height": "25px",
      "padding": "7px",
      "font-size": "0.9rem",
      "margin-right": "9px"
    },
    attrs: {
      "id": "HubName",
      "options": _vm.HubOptionObj,
      "selected-option": _vm.HubSelectOptionObj
    },
    on: {
      "select": _vm.selectHub
    }
  }) : _vm._e(), _vm._v(" "), (_vm.clientListButton) ? _c('basic-select', {
    staticStyle: {
      "float": "right",
      "width": "25%",
      "margin-top": "-8px",
      "height": "30px",
      "min-height": "25px",
      "padding": "7px",
      "font-size": "0.9rem",
      "margin-right": "9px"
    },
    attrs: {
      "id": "ClientName",
      "options": _vm.clientlistObj,
      "selected-option": _vm.clientlistOptionObj
    },
    on: {
      "select": _vm.selectClient
    }
  }) : _vm._e(), _vm._v(" "), (_vm.clientListSpan) ? _c('span', {
    staticStyle: {
      "color": "red",
      "float": "right",
      "margin-right": "9px"
    }
  }, [_vm._v("Client not\n\t\t\t\t\t\t\tassigned\n\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row top_row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card top_cards_main"
  }, [_c('div', {
    staticClass: "card-header top_cards"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-number"
  }, [_c('a', {
    staticClass: "text_sub_head",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.Enquirymodal = true
      }
    }
  }, [_vm._v(_vm._s(_vm.TicketsSummery.Inquiry.TotalCound))])]), _vm._v(" "), _c('div', {
    staticClass: "view-details"
  }, [_c('a', {
    staticClass: "text_noti",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.Enquirymodal = true
      }
    }
  }, [_vm._v("View Details")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card top_cards_main"
  }, [_c('div', {
    staticClass: "card-header top_cards"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-number"
  }, [_c('a', {
    staticClass: "text_sub_head",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.Requestmodal = true
      }
    }
  }, [_vm._v(_vm._s(_vm.TicketsSummery.Request.TotalCound))])]), _vm._v(" "), _c('div', {
    staticClass: "view-details"
  }, [_c('a', {
    staticClass: "text_noti",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.Requestmodal = true
      }
    }
  }, [_vm._v("View Details")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card top_cards_main"
  }, [_c('div', {
    staticClass: "card-header top_cards"
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "card-number"
  }, [_c('a', {
    staticClass: "text_sub_head",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.complaintmodal = true
      }
    }
  }, [_vm._v(_vm._s(_vm.TicketsSummery.Complaint.TotalCound))])]), _vm._v(" "), _c('div', {
    staticClass: "view-details"
  }, [_c('a', {
    staticClass: "text_noti",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.complaintmodal = true
      }
    }
  }, [_vm._v("View\n\t\t\t\t\t\t\t\t\t\t\t\tDetails")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-lg-3"
  }, [_c('div', {
    staticClass: "card card_shadow_effect"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h6', [_vm._v("MTD Reattempt Conversion")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link btnRefreshIcon",
    attrs: {
      "type": "button",
      "title": "Refresh"
    },
    on: {
      "click": function($event) {
        _vm.getMTDReattemptRefresh()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh text-primary"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('highcharts', {
    attrs: {
      "options": _vm.MTDreatempt
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-lg-3"
  }, [_c('div', {
    staticClass: "card card_shadow_effect"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h6', [_vm._v("MTD Escalation Conversion")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link btnRefreshIcon",
    attrs: {
      "type": "button",
      "title": "Refresh"
    },
    on: {
      "click": function($event) {
        _vm.getMTDEscalationRefresh()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh text-primary"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('highcharts', {
    attrs: {
      "options": _vm.MTDEscalation
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-lg-3"
  }, [_c('div', {
    staticClass: "card card_shadow_effect"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h6', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("Top 5 Locations (Request)")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link btnRefreshIconLoc",
    attrs: {
      "type": "button",
      "title": "Refresh"
    },
    on: {
      "click": function($event) {
        _vm.getTop_5_Locations_ComplaintRefresh()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh text-primary"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-body",
    staticStyle: {
      "padding-top": "4px",
      "height": "165px"
    }
  }, [_c('ul', {
    attrs: {
      "id": "complaintLocation"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoadingTopLocationsComplaint,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingTopLocationsComplaint = $event
      }
    }
  }), _vm._v(" "), _vm._l((_vm.TicketsSummery.TopLocations.Toplocation), function(item) {
    return _c('li', [_c('a', {
      staticStyle: {
        "color": "black"
      },
      attrs: {
        "href": '#'
      },
      on: {
        "click": function($event) {
          _vm.showSummaryTicketData1(item.hub, item.hubname, 'Lo_Request')
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.hubname) + " "), _c('span', {
      staticClass: "badge",
      staticStyle: {
        "border-radius": "8px",
        "padding": "3px 8px",
        "background-color": "#FF0000",
        "margin": "10px 5px 5px 10px"
      }
    }, [_vm._v(_vm._s(item.total_count))])])])
  })], 2), _vm._v(" "), (_vm.TicketsSummery.TopLocations.ToplocationCount <= 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("No\n\t\t\t\t\t\t\t\t\t\t\t\ttickets\n\t\t\t\t\t\t\t\t\t\t\t")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-lg-3"
  }, [_c('div', {
    staticClass: "card card_shadow_effect"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h6', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("Top 5 Locations (Complaints)")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link btnRefreshIconLoc",
    attrs: {
      "type": "button",
      "title": "Refresh"
    },
    on: {
      "click": function($event) {
        _vm.getTop_5_Locations_EscalationRefresh()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh text-primary"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-body",
    staticStyle: {
      "padding-top": "4px",
      "height": "165px"
    }
  }, [_c('ul', {
    attrs: {
      "id": "EscalationLocation"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoadingTopLocationsEscalation,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingTopLocationsEscalation = $event
      }
    }
  }), _vm._v(" "), _vm._l((_vm.TicketsSummery.TopLocations.ToplocationEscalation), function(item) {
    return _c('li', [_c('a', {
      staticStyle: {
        "color": "black"
      },
      attrs: {
        "href": '#'
      },
      on: {
        "click": function($event) {
          _vm.showSummaryTicketData1(item.hub, item.hubname, 'Lo_Complaint')
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.hubname) + " "), _c('span', {
      staticClass: "badge",
      staticStyle: {
        "border-radius": "8px",
        "padding": "3px 8px",
        "background-color": "#FF0000",
        "margin": "10px 5px 5px"
      }
    }, [_vm._v(_vm._s(item.total_count))])])])
  })], 2), _vm._v(" "), (_vm.TicketsSummery.TopLocations.TopEscalationCount <= 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("No\n\t\t\t\t\t\t\t\t\t\t\t\ttickets\n\t\t\t\t\t\t\t\t\t\t\t")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-6"
  }, [_c('loading', {
    attrs: {
      "active": _vm.CSAWStatusSummaryLoading,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.CSAWStatusSummaryLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card card_shadow_effect"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h6', [_vm._v("CSAW Shipment Status Summary")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link btnRefreshIcon",
    attrs: {
      "type": "button",
      "title": "Refresh"
    },
    on: {
      "click": function($event) {
        _vm.getCSAWStatusSummaryRefresh()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh text-primary"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [(this.chartCSAWOptions.totalcount > 0) ? _c('highcharts', {
    attrs: {
      "options": _vm.chartCSAWOptions
    }
  }) : _vm._e(), _vm._v(" "), (this.chartCSAWOptions.totalcount <= 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("No Shipments\n\t\t\t\t\t\t\t\t\t\t\t")])]) : _vm._e()], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "card card_shadow_effect"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h6', [_vm._v("MTD Cancellation Reasons")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link btnRefreshIcon",
    attrs: {
      "type": "button",
      "title": "Refresh"
    },
    on: {
      "click": function($event) {
        _vm.getCancellationReasonsRefresh()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh text-primary"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoadingCancellationReasons,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingCancellationReasons = $event
      }
    }
  }), _vm._v(" "), (this.CancellationReasons.totalCount > 0) ? _c('highcharts', {
    attrs: {
      "options": _vm.CancellationReasons
    }
  }) : _vm._e(), _vm._v(" "), (this.CancellationReasons.totalCount <= 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("No\n\t\t\t\t\t\t\t\t\t\t\t\ttickets\n\t\t\t\t\t\t\t\t\t\t\t")])]) : _vm._e()], 1)])])])])])]), _vm._v(" "), (_vm.InboundMainDiv) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12",
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 pdr"
  }, [_c('div', {
    staticClass: "card top_card inbound card_shadow_effect"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "card-body",
    staticStyle: {
      "padding": "13px",
      "text-align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoadingTopInboundContact,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingTopInboundContact = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inner_box_inbound inbox_2 inbox_margin"
  }, [_c('p', {
    staticClass: "inner_box_header"
  }, [_vm._v("AHT")]), _vm._v(" "), _c('p', {
    staticClass: "inner_box_count"
  }, [_vm._v(_vm._s(_vm.InboundContactCenter.AHT))])]), _vm._v(" "), _c('div', {
    staticClass: "inner_box_inbound inbox_3 inbox_margin"
  }, [_c('p', {
    staticClass: "inner_box_header"
  }, [_vm._v("Hold")]), _vm._v(" "), _c('p', {
    staticClass: "inner_box_count"
  }, [_vm._v(_vm._s(_vm.InboundContactCenter.holdTime))])]), _vm._v(" "), _c('div', {
    staticClass: "inner_box_inbound inbox_4 inbox_margin"
  }, [_c('p', {
    staticClass: "inner_box_header"
  }, [_vm._v("Esc AHT")]), _vm._v(" "), _c('p', {
    staticClass: "inner_box_count"
  }, [_vm._v(_vm._s(_vm.InboundContactCenter.Esc))])]), _vm._v(" "), _c('div', {
    staticClass: "inner_box_inbound inbox_5 inbox_margin"
  }, [_c('p', {
    staticClass: "inner_box_header"
  }, [_vm._v("Repeat")]), _vm._v(" "), _c('p', {
    staticClass: "inner_box_count"
  }, [_vm._v(_vm._s(_vm.InboundContactCenter.RepeatCalls))])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 pdr"
  }, [_c('div', {
    staticClass: "card top_card inbound card_shadow_effect"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "card-body",
    staticStyle: {
      "padding": "13px",
      "text-align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoadingTopInboundContactMTD,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingTopInboundContactMTD = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inner_box_inbound inbox_1"
  }, [_c('p', {
    staticClass: "inner_box_header"
  }, [_vm._v("SL%")]), _vm._v(" "), _c('p', {
    staticClass: "inner_box_count"
  }, [_vm._v(_vm._s(_vm.InboundContactCenter.serviceLevel) + " %")])]), _vm._v(" "), _c('div', {
    staticClass: "inner_box_inbound inbox_1"
  }, [_c('p', {
    staticClass: "inner_box_header"
  }, [_vm._v("Missed")]), _vm._v(" "), _c('p', {
    staticClass: "inner_box_count"
  }, [_vm._v(_vm._s(_vm.InboundContactCenter.MissedCallMTD))])]), _vm._v(" "), _c('div', {
    staticClass: "inner_box_inbound inbox_1"
  }, [_c('p', {
    staticClass: "inner_box_header"
  }, [_vm._v("Repeat")]), _vm._v(" "), _c('p', {
    staticClass: "inner_box_count"
  }, [_vm._v(_vm._s(_vm.InboundContactCenter.RepeatCallsMTD))])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4"
  }, [_c('div', {
    staticClass: "card top_card inbound card_shadow_effect"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "card-body twitter",
    staticStyle: {
      "padding": "13px",
      "text-align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoadingTwitterTickets,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingTwitterTickets = $event
      }
    }
  }), _vm._v(" "), _vm._l((_vm.TicketsSummery.TwitterTickets.TwitterTicket), function(TwitterTicketele, index) {
    return _c('div', {
      staticClass: "inner_box_inbound inbox_2"
    }, [_c('p', {
      staticClass: "inner_box_header"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(TwitterTicketele.maintype))]), _vm._v(" "), _c('p', {
      staticClass: "inner_box_count"
    }, [_c('a', {
      staticStyle: {
        "color": "#fff"
      },
      attrs: {
        "href": '#'
      },
      on: {
        "click": function($event) {
          _vm.showSummaryTicketData1('', '', 'Tw' + TwitterTicketele.maintype)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(TwitterTicketele.total_count) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")])])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "card card_shadow_effect"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoadingInboundCallsTrend,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingInboundCallsTrend = $event
      }
    }
  }), _vm._v(" "), _c('highcharts', {
    attrs: {
      "options": _vm.chartLineOptions
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 col-lg-7"
  }, [_c('div', {
    staticClass: "card card_shadow_effect"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoadingInboundCallsFibucation,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingInboundCallsFibucation = $event
      }
    }
  }), _vm._v(" "), _c('highcharts', {
    attrs: {
      "options": _vm.InboundcallsPie
    }
  })], 1)])])])])])]) : _vm._e(), _vm._v(" "), (_vm.OutboundMainDiv) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12",
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "card top_card outbound card_shadow_effect"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "card-body",
    staticStyle: {
      "padding": "13px",
      "text-align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoadingOutboundContactTodayPerformance,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingOutboundContactTodayPerformance = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inner_box inbox_2 box_outbound"
  }, [_c('p', {
    staticClass: "inner_box_header"
  }, [_vm._v("AHT")]), _vm._v(" "), _c('p', {
    staticClass: "inner_box_count"
  }, [_vm._v(_vm._s(_vm.OutBoundContactCenter.AHT))])]), _vm._v(" "), _c('div', {
    staticClass: "inner_box inbox_3 box_outbound"
  }, [_c('p', {
    staticClass: "inner_box_header"
  }, [_vm._v("Hold")]), _vm._v(" "), _c('p', {
    staticClass: "inner_box_count"
  }, [_vm._v(_vm._s(_vm.OutBoundContactCenter.HoldTime))])]), _vm._v(" "), _c('div', {
    staticClass: "inner_box inbox_4 box_outbound"
  }, [_c('p', {
    staticClass: "inner_box_header"
  }, [_vm._v("Fake")]), _vm._v(" "), _c('p', {
    staticClass: "inner_box_count"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoadingOutboundContactFack,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingOutboundContactFack = $event
      }
    }
  }), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": '#'
    },
    on: {
      "click": function($event) {
        _vm.showSummaryTicketData1('', '', 'Complaint_fake')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.OutBoundContactCenter.Fake) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "inner_box inbox_5 box_outbound"
  }, [_c('p', {
    staticClass: "inner_box_header"
  }, [_vm._v("Missed")]), _vm._v(" "), _c('p', {
    staticClass: "inner_box_count"
  }, [_vm._v(_vm._s(_vm.OutBoundContactCenter.Missed))])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "card top_card outbound card_shadow_effect"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "card-body",
    staticStyle: {
      "padding": "13px",
      "text-align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoadingOutboundContactMTDPerformance,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingOutboundContactMTDPerformance = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inner_box inbox_2 box_outbound"
  }, [_c('p', {
    staticClass: "inner_box_header"
  }, [_vm._v("AHT")]), _vm._v(" "), _c('p', {
    staticClass: "inner_box_count"
  }, [_vm._v(_vm._s(_vm.OutBoundMTDContactCenter.AHT))])]), _vm._v(" "), _c('div', {
    staticClass: "inner_box inbox_3 box_outbound"
  }, [_c('p', {
    staticClass: "inner_box_header"
  }, [_vm._v("Hold")]), _vm._v(" "), _c('p', {
    staticClass: "inner_box_count"
  }, [_vm._v(_vm._s(_vm.OutBoundMTDContactCenter.HoldTime))])]), _vm._v(" "), _c('div', {
    staticClass: "inner_box inbox_4 box_outbound"
  }, [_c('p', {
    staticClass: "inner_box_header"
  }, [_vm._v("Fake")]), _vm._v(" "), _c('p', {
    staticClass: "inner_box_count"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoadingOutBoundMTDContactCenterFack,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingOutBoundMTDContactCenterFack = $event
      }
    }
  }), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": '#'
    },
    on: {
      "click": function($event) {
        _vm.showSummaryTicketData1('', '', 'Complaint_MTDfake')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.OutBoundMTDContactCenter.Fake) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "inner_box inbox_5 box_outbound"
  }, [_c('p', {
    staticClass: "inner_box_header"
  }, [_vm._v("Missed")]), _vm._v(" "), _c('p', {
    staticClass: "inner_box_count"
  }, [_vm._v(_vm._s(_vm.OutBoundMTDContactCenter.Missed))])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "card card_shadow_effect"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [(_vm.NDRCallSummary.NDRCnt > 0) ? _c('div', {
    attrs: {
      "id": "ndrcallline"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoadingNDRCallLineChart,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingNDRCallLineChart = $event
      }
    }
  }), _vm._v(" "), _c('highcharts', {
    attrs: {
      "options": _vm.NDRcallsLine
    }
  }), _c('br')], 1) : _vm._e(), _vm._v(" "), (_vm.NDRCallSummary.NDRCnt > 0) ? _c('div', {
    attrs: {
      "id": "ndrcalltable"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoadingNDRCallSummary,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingNDRCallSummary = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-responsive table-bordered cus_style_table ",
    staticStyle: {
      "width": "100%",
      "max-width": "100%"
    }
  }, [_vm._m(16), _vm._v(" "), _c('tbody', [_vm._l((_vm.NDRCallSummary.NDRCallSummaryData), function(NDRCallSummaryele, index) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(NDRCallSummaryele.Languages) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(NDRCallSummaryele.TotalDownload))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(NDRCallSummaryele.NotDialed))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(NDRCallSummaryele.Dialed))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(NDRCallSummaryele.Success))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(NDRCallSummaryele.Failed))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(NDRCallSummaryele.Missed))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.NDRCallSummary.DownloadedTotal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.NDRCallSummary.NotDialedTotal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.NDRCallSummary.DialedTotal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.NDRCallSummary.SuccessTotal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.NDRCallSummary.FailedTotal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.NDRCallSummary.MissedTotal))])])], 2)])], 1) : _vm._e(), _vm._v(" "), (this.NDRCallSummary.NDRCnt <= 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("No\n\t\t\t\t\t\t\t\t\t\t\t\tdata\n\t\t\t\t\t\t\t\t\t\t\t")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "card card_shadow_effect"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('basic-select', {
    staticStyle: {
      "float": "right",
      "margin-top": "-8px",
      "height": "30px",
      "min-height": "25px",
      "padding": "7px",
      "font-size": "14px",
      "width": "30%"
    },
    attrs: {
      "options": _vm.AutoIVRSelectOptionArr,
      "selected-option": _vm.AutoIVRSelectOptionObj
    },
    on: {
      "select": _vm.AutoIVROption
    }
  }), _vm._v(" "), _c('h6', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("Auto IVR Call\n\t\t\t\t\t\t\t\t\t\t\tSummary")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [(_vm.showTable == 1) ? _c('div', {
    staticClass: "AutoIVRCallLine"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoadingAutoIVRCallLine,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingAutoIVRCallLine = $event
      }
    }
  }), _vm._v(" "), _c('highcharts', {
    attrs: {
      "options": _vm.AutoIVRCallsLine
    }
  }), _c('br')], 1) : _vm._e(), _vm._v(" "), (_vm.showTable == 1) ? _c('div', {
    staticClass: "AutoIVRCallTable"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoadingAutoIVRCallTable,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingAutoIVRCallTable = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-responsive table-bordered cus_style_table",
    staticStyle: {
      "width": "100%",
      "max-width": "100%"
    }
  }, [(_vm.AutoIVRCallSummary.DialerType == '1' || _vm.AutoIVRCallSummary.DialerType == '2') ? _c('thead', [_c('th', [_vm._v("Zone")]), _vm._v(" "), _c('th', [_vm._v("Total Calls")]), _vm._v(" "), _c('th', [_vm._v("Success")]), _vm._v(" "), _c('th', [_vm._v("Failed")]), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('th', [_vm._v("Isbusy")]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('th', [_vm._v("Congestion")])]) : _vm._e(), _vm._v(" "), (_vm.AutoIVRCallSummary.DialerType == '3') ? _c('thead', [_c('th', [_vm._v("Zone")]), _vm._v(" "), _c('th', [_vm._v("Total Calls")]), _vm._v(" "), _c('th', [_vm._v("Success")]), _vm._v(" "), _c('th', [_vm._v("Failed")]), _vm._v(" "), _c('th', [_vm._v("Delivered")]), _vm._v(" "), _c('th', [_vm._v("Not Delivered")]), _vm._v(" "), _c('th', [_vm._v("No Responce")])]) : _vm._e(), _vm._v(" "), (_vm.AutoIVRCallSummary.AutoIVRCnt > 0) ? _c('tbody', _vm._l((_vm.AutoIVRCallSummary.AutoIVRCallSummaryData), function(AutoIVRCallSummaryele, index) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(AutoIVRCallSummaryele.HubZone) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(AutoIVRCallSummaryele.TotalCalls))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(AutoIVRCallSummaryele.Success))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(AutoIVRCallSummaryele.Faild))]), _vm._v(" "), (_vm.AutoIVRCallSummary.DialerType == '1') ? _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(AutoIVRCallSummaryele.WrongNumber))]) : _vm._e(), _vm._v(" "), (_vm.AutoIVRCallSummary.DialerType == '1') ? _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(AutoIVRCallSummaryele.Isbusy))]) : _vm._e(), _vm._v(" "), (_vm.AutoIVRCallSummary.DialerType == '1') ? _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(AutoIVRCallSummaryele.Isringing))]) : _vm._e(), _vm._v(" "), (_vm.AutoIVRCallSummary.DialerType == '1') ? _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(AutoIVRCallSummaryele.Congestion))]) : _vm._e(), _vm._v(" "), (_vm.AutoIVRCallSummary.DialerType == '2') ? _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(AutoIVRCallSummaryele.WrongNumber))]) : _vm._e(), _vm._v(" "), (_vm.AutoIVRCallSummary.DialerType == '2') ? _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(AutoIVRCallSummaryele.Isbusy))]) : _vm._e(), _vm._v(" "), (_vm.AutoIVRCallSummary.DialerType == '2') ? _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(AutoIVRCallSummaryele.Isringing))]) : _vm._e(), _vm._v(" "), (_vm.AutoIVRCallSummary.DialerType == '2') ? _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(AutoIVRCallSummaryele.Congestion))]) : _vm._e(), _vm._v(" "), (_vm.AutoIVRCallSummary.DialerType == '3') ? _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(AutoIVRCallSummaryele.Delivered))]) : _vm._e(), _vm._v(" "), (_vm.AutoIVRCallSummary.DialerType == '3') ? _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(AutoIVRCallSummaryele.NotDelivered))]) : _vm._e(), _vm._v(" "), (_vm.AutoIVRCallSummary.DialerType == '3') ? _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(AutoIVRCallSummaryele.NoResponce))]) : _vm._e()])
  })) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.AutoIVRCallSummary.AutoIVRCnt <= 0 && _vm.showTable == 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("No Data\n\t\t\t\t\t\t\t\t\t\t\t")])]) : _vm._e()])])])])])])]) : _vm._e()])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "no-close-on-esc": true,
      "no-close-on-backdrop": true
    },
    on: {
      "close": function($event) {
        _vm.TicketsSummery.Ticketsummerymodal = false
      }
    },
    model: {
      value: (_vm.TicketsSummery.Ticketsummerymodal),
      callback: function($$v) {
        _vm.TicketsSummery.Ticketsummerymodal = $$v
      },
      expression: "TicketsSummery.Ticketsummerymodal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.TicketsSummery.Ticketsummerymodal),
      expression: "TicketsSummery.Ticketsummerymodal"
    }],
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "0px",
      "padding": "20px"
    }
  }, [_c('div', [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.TicketsSummery.TicketTypeName))])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "type": "button",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeTicketsummerymodal()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: " form-control col-md-3",
    staticStyle: {
      "float": "right",
      "margin-right": "23px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Shipping Id/Source/Sub Reason",
      "title": "Search Shipping Id/Source/Sub Reason"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.OnFilterClick,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showEditBulkButton == true) ? _c('div', [_c('router-link', {
    staticClass: "btn btn-primary cst_btn",
    attrs: {
      "to": {
        name: 'bulkshipment',
        params: {
          message: 'edit_bulk_tickets',
          ticketSummeryListforBulkEdit: _vm.ticketSummeryListforBulkEdit,
          businessFlowObj: _vm.SummarySelectOptionObj,
          clientName: _vm.clientlistOptionObj.text,
          useridBulk: _vm.useridBulk,
          deptidBulk: _vm.deptidBulk,
          hubObj: _vm.HubSelectOptionObj,
          type: _vm.type,
          userClientNameBulk: _vm.userClientNameBulk
        }
      }
    }
  }, [_vm._v("Bulk Update")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table-responsive table-bordered",
    staticStyle: {
      "width": "100%",
      "max-width": "100%"
    }
  }, [_c('thead', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipping Id")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Ticket Id")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Ticket Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Reattempt Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Type Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Source")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Sub Reason")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Department")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Priority")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("TAT")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Aging Days")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.TicketsSummery.TicketSummeryList), function(TicketsSummeryele, index) {
    return _c('tr', [_c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'trackshipmentsummarydetail',
          params: {
            id: TicketsSummeryele.shippingid
          }
        },
        "event": _vm.trackShipmentAccess == true ? 'click' : ''
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(TicketsSummeryele.shippingid))])], 1), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(TicketsSummeryele.ticketid))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(TicketsSummeryele.ticketstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(TicketsSummeryele.reattemptdate))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(TicketsSummeryele.reasonid))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(TicketsSummeryele.sourceid))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(TicketsSummeryele.subreasonid))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(_vm._f("formatDatesingle")(TicketsSummeryele.createddate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(TicketsSummeryele.createdby))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(TicketsSummeryele.department))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(TicketsSummeryele.priority))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(TicketsSummeryele.hub))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(TicketsSummeryele.tat))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(TicketsSummeryele.aging_days))])])
  }))]), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoadingPagination,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingPagination = $event
      }
    }
  }), _vm._v(" "), (_vm.pagecount > 1) ? _c('paginate', {
    ref: "paginate",
    staticStyle: {
      "margin-top": "11px"
    },
    attrs: {
      "page-count": _vm.pagecount,
      "margin-pages": 3,
      "click-handler": _vm.getPaginationData,
      "prev-text": '⏮',
      "next-text": '⏭',
      "container-class": 'pagination',
      "page-class": 'page-item',
      "pageLinkClass": 'page-link-item'
    }
  }) : _vm._e()], 1)])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "no-close-on-backdrop": true
    },
    on: {
      "close": function($event) {
        _vm.Enquirymodal = false
      }
    },
    model: {
      value: (_vm.Enquirymodal),
      callback: function($$v) {
        _vm.Enquirymodal = $$v
      },
      expression: "Enquirymodal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Enquirymodal),
      expression: "Enquirymodal"
    }],
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h5', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Enquiry")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "type": "button",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.Enquirymodal = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_vm._l((_vm.TicketsSummery.Inquiry.InquiryData), function(Inquiryele, index) {
    return _c('div', {
      staticClass: "enq_container top_container_holdr"
    }, [_c('p', {
      staticClass: "enq_name"
    }, [_c('a', {
      staticStyle: {
        "color": "white"
      },
      attrs: {
        "href": '#'
      },
      on: {
        "click": function($event) {
          _vm.showSummaryTicketData1(Inquiryele.subResone, '', 'Inquiry')
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(Inquiryele.Name) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('p', {
      staticClass: "enq_number"
    }, [_c('a', {
      staticStyle: {
        "color": "black"
      },
      attrs: {
        "href": '#'
      },
      on: {
        "click": function($event) {
          _vm.showSummaryTicketData1(Inquiryele.subResone, '', 'Inquiry')
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(Inquiryele.Values) + "\n\t\t\t\t\t\t")])])])
  }), _vm._v(" "), (_vm.TicketsSummery.Inquiry.TotalCound <= 0) ? _c('div', [_c('div', {
    staticClass: "text-center text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("No\n\t\t\t\t\t\ttickets\n\t\t\t\t\t")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "no-close-on-backdrop": true
    },
    on: {
      "close": function($event) {
        _vm.Requestmodal = false
      }
    },
    model: {
      value: (_vm.Requestmodal),
      callback: function($$v) {
        _vm.Requestmodal = $$v
      },
      expression: "Requestmodal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Requestmodal),
      expression: "Requestmodal"
    }],
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h5', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Request")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "type": "button",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.Requestmodal = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_vm._l((_vm.TicketsSummery.Request.RequestData), function(Requestele, index) {
    return _c('div', {
      staticClass: "rq_container top_container_holdr"
    }, [_c('p', {
      staticClass: "rq_name"
    }, [_c('a', {
      staticStyle: {
        "color": "white"
      },
      attrs: {
        "href": '#'
      },
      on: {
        "click": function($event) {
          _vm.showSummaryTicketData1(Requestele.subResone, '', 'Request')
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(Requestele.Name) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('p', {
      staticClass: "rq_number"
    }, [_c('a', {
      attrs: {
        "href": '#'
      },
      on: {
        "click": function($event) {
          _vm.showSummaryTicketData1(Requestele.subResone, '', 'Request')
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(Requestele.Values) + "\n\t\t\t\t\t\t")])])])
  }), _vm._v(" "), (_vm.TicketsSummery.Request.TotalCound <= 0) ? _c('div', [_c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("No\n\t\t\t\t\t\ttickets\n\t\t\t\t\t")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "no-close-on-backdrop": true
    },
    on: {
      "close": function($event) {
        _vm.complaintmodal = false
      }
    },
    model: {
      value: (_vm.complaintmodal),
      callback: function($$v) {
        _vm.complaintmodal = $$v
      },
      expression: "complaintmodal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.complaintmodal),
      expression: "complaintmodal"
    }],
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h5', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Complaint")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "type": "button",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.complaintmodal = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_vm._l((_vm.TicketsSummery.Complaint.ComplaintData), function(Complaintele, index) {
    return _c('div', {
      staticClass: "comp_container top_container_holdr"
    }, [_c('p', {
      staticClass: "comp_name"
    }, [_c('a', {
      staticStyle: {
        "color": "white"
      },
      attrs: {
        "href": '#'
      },
      on: {
        "click": function($event) {
          _vm.showSummaryTicketData1(Complaintele.subResone, '', 'Complaint')
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(Complaintele.Name) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('p', {
      staticClass: "comp_number"
    }, [_c('a', {
      attrs: {
        "href": '#'
      },
      on: {
        "click": function($event) {
          _vm.showSummaryTicketData1(Complaintele.subResone, '', 'Complaint')
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(Complaintele.Values) + "\n\t\t\t\t\t\t")])])])
  }), _vm._v(" "), (_vm.TicketsSummery.Complaint.TotalCound <= 0) ? _c('div', [_c('div', {
    staticClass: "text-center text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("No\n\t\t\t\t\t\ttickets\n\t\t\t\t\t")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "no-close-on-backdrop": true
    },
    on: {
      "close": function($event) {
        _vm.Escalationmodal = false
      }
    },
    model: {
      value: (_vm.Escalationmodal),
      callback: function($$v) {
        _vm.Escalationmodal = $$v
      },
      expression: "Escalationmodal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Escalationmodal),
      expression: "Escalationmodal"
    }],
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h5', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Escalation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "type": "button",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.Escalationmodal = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_vm._l((_vm.TicketsSummery.Escalation.EscalationData), function(Escalationele, index) {
    return _c('div', {
      staticClass: "esc_container top_container_holdr"
    }, [_c('p', {
      staticClass: "esc_name"
    }, [_c('a', {
      staticStyle: {
        "color": "white"
      },
      attrs: {
        "href": '#'
      },
      on: {
        "click": function($event) {
          _vm.showSummaryTicketData1(Escalationele.subResone, '', 'Escalation')
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(Escalationele.Name) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('p', {
      staticClass: "esc_number"
    }, [_c('a', {
      attrs: {
        "href": '#'
      },
      on: {
        "click": function($event) {
          _vm.showSummaryTicketData1(Escalationele.subResone, '', 'Escalation')
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(Escalationele.Values) + "\n\t\t\t\t\t\t")])])])
  }), _vm._v(" "), (_vm.TicketsSummery.Escalation.TotalCount <= 0) ? _c('div', [_c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("No\n\t\t\t\t\t\ttickets\n\t\t\t\t\t")])]) : _vm._e()], 2)])])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-icon orange_background"
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-title"
  }, [_c('p', {
    staticClass: "text_head"
  }, [_vm._v("Enquiry")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-icon green_background"
  }, [_c('i', {
    staticClass: "fa fa-comments",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-title"
  }, [_c('p', {
    staticClass: "text_head"
  }, [_vm._v("Request")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-icon red_background"
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-title"
  }, [_c('p', {
    staticClass: "text_head"
  }, [_vm._v("Complaint")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h5', [_vm._v("Inbound Contact Center")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card_main"
  }, [_c('p', {
    staticClass: "card_main_first_txt"
  }, [_vm._v("Today's Performance")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card_main"
  }, [_c('p', {
    staticClass: "card_main_first_txt"
  }, [_vm._v("MTD Performance")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card_main"
  }, [_c('p', {
    staticClass: "card_main_first_txt"
  }, [_vm._v("Social Media Tickets")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h6', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("Inbound Calls\n\t\t\t\t\t\t\t\t\t\t\tTrend")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h6', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("Inbound Calls Bifurcation")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h5', [_vm._v("Outbound Contact Center")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card_main"
  }, [_c('p', {
    staticClass: "card_main_first_txt"
  }, [_vm._v("Today's Performance")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card_main"
  }, [_c('p', {
    staticClass: "card_main_first_txt"
  }, [_vm._v("MTD Performance")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h6', [_vm._v("NDR Call Summary")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-dark"
  }, [_c('th', [_vm._v("Language")]), _vm._v(" "), _c('th', [_vm._v("Total"), _c('br'), _vm._v("Download")]), _vm._v(" "), _c('th', [_vm._v("Pending")]), _vm._v(" "), _c('th', [_vm._v("Dialed")]), _vm._v(" "), _c('th', [_vm._v("Success")]), _vm._v(" "), _c('th', [_vm._v("Failed")]), _vm._v(" "), _c('th', [_vm._v("Missed")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Wrong"), _c('br'), _vm._v("Number")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Is"), _c('br'), _vm._v("ringing")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cfb5910","hasScoped":true}!./src/views/components/dashboard/dashboard.component.html
// module id = 599
// module chunks = 1